import { getUID } from '@redviking/argonaut-util/src/getUID';
import { UiFlowNodeControl } from '../../controls/UiFlowNodeControl';
import type { UiNodeSpec } from './UiNodeSpec';
import { createNodeSocket } from '../../sync-utils/create-node-socket';
import { removeNodeSocket } from '../../sync-utils/remove-node-socket';

export const txtFormatUiNodeSpec: UiNodeSpec<'txtFormat'> = {
    requiredSockets: [ 'output' ],
    cfg: () => ({ controlValues: { formatTemplate: '', inputs: 0 }, id: getUID(), kind: 'txtFormat', disabled: false }),
    controls: getNodeCfg => ({
        formatTemplate: {
            cfg: { kind: 'textarea', placeholder: 'Format', rows: 5 },
            index: 0,
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.formatTemplate,
        },
        inputs: {
            cfg: {
                kind: 'button',
                label: 'Add Input',
                onClick: () => {
                    const nodeCfg = getNodeCfg();
                    createNodeSocket({
                        newNodeCfg: {
                            ...nodeCfg,
                            controlValues: {
                                ...nodeCfg.controlValues,
                                inputs: nodeCfg.controlValues.inputs + 1,
                            },
                        },
                    });
                },
            },
            index: 1,
            nodeCfg: getNodeCfg(),
            value: getNodeCfg().controlValues.inputs,
        },
    }),
    inputs: nodeCfg => {
        const inputs: ReturnType<UiNodeSpec<'txtFormat'>['inputs']> = {};
        for (let i = 0; i < nodeCfg.controlValues.inputs; i++) {
            const control: UiFlowNodeControl.Opts<unknown> = ({
                cfg: {
                    kind: 'deletableSocket',
                    label: `$${i}`,
                    onDelete () {
                        removeNodeSocket({
                            newNodeCfg: {
                                ...nodeCfg,
                                controlValues: {
                                    ...nodeCfg.controlValues,
                                    inputs: nodeCfg.controlValues.inputs - 1,
                                },
                            },
                            direction: 'input',
                            removalMethod: {
                                index: i,
                                prefix: 'input',
                                kind: 'indexedIdentifier',
                            },
                        });
                    },
                },
                nodeCfg,
                value: null,
                socketDefault: false,
            });
            inputs[`input${i}`] = {
                control,
                socket: 'varValue',
            };
        }
        return inputs;
    },
    kindLabel: 'Text Format',
    nodeCategory: 'text',
    outputs: () => ({ output: { socket: 'string', label: 'Output' } }),
    validator: node => {
        const errors: Record<string, string> = {};
        if (!node.controlValues.formatTemplate) {
            errors.formatTemplate = 'Format Template is required';
        }
        return Object.keys(errors).length ? errors : true;
    },
};
